// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../shared/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../shared/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../shared/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[1]!../../../../../shared/node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[2]!../../styles/customMediaQueries.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Dashboard_root__Lo2Zz {
  margin: 20px 20px;
  gap: 24px;
  
  & .ant-table-tbody tr:nth-child(even) td {
	  background-color: #f4f4f4;
	}

}

.Dashboard_datePicker__o1rsL {
  width: 100%;
}

.Dashboard_searchFormContainer__HjcuQ {
  gap: 10px;

  @media (min-width: 992px) {
	  gap: 10px 0;
  }
}

.Dashboard_actionContainer__Na6Pi {
  display: flex;
  align-items: center;
  gap: 10px;
}

.Dashboard_actionIcon__rdxtb {
  display: flex;
  cursor: pointer;
}

.Dashboard_actionsWrapper__-uF9v {
  display: flex;
  gap: 8px;
  justify-content: space-between;
  
  @media (min-width: 576px) {
    justify-content: flex-end;
    gap: 16px;
  }
}

.Dashboard_formItem__pq\\+bC {
  display: flex;
  flex-direction: column;
  gap: 5px;
  
  @media (min-width: 576px) {
    flex-direction: row;
    align-items: center;
  }

  label {
    white-space: nowrap;
    text-align: left;
    flex-shrink: 0;

    @media (min-width: 576px) {
      min-width: 100px;
    }

    @media (min-width: 992px) {
      min-width: 1px;
    }
  }

  .ant-form-item {
    width: 100%;
    margin-bottom: 0;
  }
}

.Dashboard_sectionDatepickerFilterHolder__E-ygR {
  display: flex;
  flex-direction: column;
  gap: 10px;

  & .ant-picker-outlined {
    width: auto;
  }

  @media (min-width: 1024px) {
    flex-direction: row;
  }
}

.Dashboard_lastUpdateRow__mKBpF {
  display: flex;
  gap: 24px;
  margin-bottom: 10px;
  flex-direction: column;
  text-align: left;
  margin-bottom: 24px;

  @media (min-width: 576px) {
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
  }
}

.Dashboard_lastUpdate__Y7aWQ {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  flex-basis: 45%;
  
  @media (min-width: 1024px) {
    align-items: center;
    flex-direction: row;
  }
  
  @media (min-width: 1200px) {
    min-width: 400px;
    flex-basis: auto;
  }
}

.Dashboard_lastUpdateTitle__l0npc {
  font-size: 16px;
  white-space: nowrap;
}

.Dashboard_lastUpdateText__z1LBc {
  font-size: 14px;
  white-space: nowrap;
  color: rgba(0, 0, 0, 0.45);
}

.Dashboard_lastUpdateItemTitle__HzLe6 {
  font-size: 14px;
  line-height: 29px;
  white-space: nowrap;
  margin: 0;
}

.Dashboard_lastUpdateItem__zi7km {
  display: flex;
  flex-direction: column;
  flex-basis: 45%;
  
  @media (min-width: 1024px) {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 24px;
    flex-basis: 30%;
  }
  
  @media (min-width: 1400px) {
    padding: 0 16px;
    flex-basis: 15%;
    max-width: 18%;
    min-width: 250px;
  }
}

.Dashboard_lastUpdateItemText__r4mmx {
  white-space: nowrap;
  font-weight: 500;
}

.Dashboard_loginForm__K\\+b9A {
  & .ant-form-item-label {
    min-width: 100px;
  }
}

.Dashboard_backButtonContainer__p4OlG {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  background-color: #fff;
  padding: 20px 20px 0 20px;
}

.Dashboard_antTableCellClipped__vqFlZ {
	  display: inline-block; 
	  
	  width: 100%; 
	  
	  white-space: nowrap;
	  overflow: hidden;
	  text-overflow: ellipsis;
	
}

/* doesn't work, was suposed to be used with className for Alert */

.Dashboard_ant-alert__9ph8y.Dashboard_custom-black-alert__LRxt6 {
  /* Targets the root element */
  background-color: black !important;
  border-color: gray !important;
}

.Dashboard_ant-alert__9ph8y.Dashboard_custom-black-alert__LRxt6 .Dashboard_ant-alert-message__\\+DCIo,
.Dashboard_ant-alert__9ph8y.Dashboard_custom-black-alert__LRxt6 .Dashboard_ant-alert-description__J9ohZ {
  /* Targets the text elements */
  color: white !important;
}

.Dashboard_ant-alert__9ph8y.Dashboard_custom-black-alert__LRxt6 .Dashboard_ant-alert-icon__XgZbs {
  /* Targets the icon */
  color: white !important;
}`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/Dashboard.module.css"],"names":[],"mappings":"AAEA;EACE,iBAAiB;EACjB,SAAS;;EAET;GACC,yBAAyB;CAC3B;;AAED;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,SAAS;;EAET;GACC,WAAW;EACZ;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,8BAA8B;;EAE9B;IACE,yBAAyB;IACzB,SAAS;EACX;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;;EAER;IACE,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;;IAEd;MACE,gBAAgB;IAClB;;IAEA;MACE,cAAc;IAChB;EACF;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;;EAET;IACE,WAAW;EACb;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;;EAEnB;IACE,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;EACtB,eAAe;;EAEf;IACE,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;AACF;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;;EAEf;IACE,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,eAAe;IACf,cAAc;IACd,gBAAgB;EAClB;AACF;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;GACG,qBAAqB;;GAErB,WAAW;;GAEX,mBAAmB;GACnB,gBAAgB;GAChB,uBAAuB;;AAE1B;;AAEA,kEAAkE;;AAElE;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,6BAA6B;AAC/B;;AAEA;;EAEE,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;AACzB","sourcesContent":["@import \"../../styles/customMediaQueries.css\";\n\n.root {\n  margin: 20px 20px;\n  gap: 24px;\n  \n  & :global(.ant-table-tbody tr:nth-child(even) td) {\n\t  background-color: #f4f4f4;\n\t}\n\n}\n\n.datePicker {\n  width: 100%;\n}\n\n.searchFormContainer {\n  gap: 10px;\n\n  @media (min-width: 992px) {\n\t  gap: 10px 0;\n  }\n}\n\n.actionContainer {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.actionIcon {\n  display: flex;\n  cursor: pointer;\n}\n\n.actionsWrapper {\n  display: flex;\n  gap: 8px;\n  justify-content: space-between;\n  \n  @media (min-width: 576px) {\n    justify-content: flex-end;\n    gap: 16px;\n  }\n}\n\n.formItem {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  \n  @media (min-width: 576px) {\n    flex-direction: row;\n    align-items: center;\n  }\n\n  label {\n    white-space: nowrap;\n    text-align: left;\n    flex-shrink: 0;\n\n    @media (min-width: 576px) {\n      min-width: 100px;\n    }\n\n    @media (min-width: 992px) {\n      min-width: 1px;\n    }\n  }\n\n  :global(.ant-form-item) {\n    width: 100%;\n    margin-bottom: 0;\n  }\n}\n\n.sectionDatepickerFilterHolder {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n\n  & :global(.ant-picker-outlined) {\n    width: auto;\n  }\n\n  @media (min-width: 1024px) {\n    flex-direction: row;\n  }\n}\n\n.lastUpdateRow {\n  display: flex;\n  gap: 24px;\n  margin-bottom: 10px;\n  flex-direction: column;\n  text-align: left;\n  margin-bottom: 24px;\n\n  @media (min-width: 576px) {\n    flex-direction: row;\n    align-items: center;\n    flex-wrap: wrap;\n  }\n}\n\n.lastUpdate {\n  display: flex;\n  justify-content: space-between;\n  flex-direction: column;\n  flex-basis: 45%;\n  \n  @media (min-width: 1024px) {\n    align-items: center;\n    flex-direction: row;\n  }\n  \n  @media (min-width: 1200px) {\n    min-width: 400px;\n    flex-basis: auto;\n  }\n}\n\n.lastUpdateTitle {\n  font-size: 16px;\n  white-space: nowrap;\n}\n\n.lastUpdateText {\n  font-size: 14px;\n  white-space: nowrap;\n  color: rgba(0, 0, 0, 0.45);\n}\n\n.lastUpdateItemTitle {\n  font-size: 14px;\n  line-height: 29px;\n  white-space: nowrap;\n  margin: 0;\n}\n\n.lastUpdateItem {\n  display: flex;\n  flex-direction: column;\n  flex-basis: 45%;\n  \n  @media (min-width: 1024px) {\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    gap: 24px;\n    flex-basis: 30%;\n  }\n  \n  @media (min-width: 1400px) {\n    padding: 0 16px;\n    flex-basis: 15%;\n    max-width: 18%;\n    min-width: 250px;\n  }\n}\n\n.lastUpdateItemText {\n  white-space: nowrap;\n  font-weight: 500;\n}\n\n.loginForm {\n  & :global(.ant-form-item-label) {\n    min-width: 100px;\n  }\n}\n\n.backButtonContainer {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  background-color: #fff;\n  padding: 20px 20px 0 20px;\n}\n\n.antTableCellClipped {\n\t  display: inline-block; \n\t  \n\t  width: 100%; \n\t  \n\t  white-space: nowrap;\n\t  overflow: hidden;\n\t  text-overflow: ellipsis;\n\t\n}\n\n/* doesn't work, was suposed to be used with className for Alert */\n\n.ant-alert.custom-black-alert {\n  /* Targets the root element */\n  background-color: black !important;\n  border-color: gray !important;\n}\n\n.ant-alert.custom-black-alert .ant-alert-message,\n.ant-alert.custom-black-alert .ant-alert-description {\n  /* Targets the text elements */\n  color: white !important;\n}\n\n.ant-alert.custom-black-alert .ant-alert-icon {\n  /* Targets the icon */\n  color: white !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `Dashboard_root__Lo2Zz`,
	"datePicker": `Dashboard_datePicker__o1rsL`,
	"searchFormContainer": `Dashboard_searchFormContainer__HjcuQ`,
	"actionContainer": `Dashboard_actionContainer__Na6Pi`,
	"actionIcon": `Dashboard_actionIcon__rdxtb`,
	"actionsWrapper": `Dashboard_actionsWrapper__-uF9v`,
	"formItem": `Dashboard_formItem__pq+bC`,
	"sectionDatepickerFilterHolder": `Dashboard_sectionDatepickerFilterHolder__E-ygR`,
	"lastUpdateRow": `Dashboard_lastUpdateRow__mKBpF`,
	"lastUpdate": `Dashboard_lastUpdate__Y7aWQ`,
	"lastUpdateTitle": `Dashboard_lastUpdateTitle__l0npc`,
	"lastUpdateText": `Dashboard_lastUpdateText__z1LBc`,
	"lastUpdateItemTitle": `Dashboard_lastUpdateItemTitle__HzLe6`,
	"lastUpdateItem": `Dashboard_lastUpdateItem__zi7km`,
	"lastUpdateItemText": `Dashboard_lastUpdateItemText__r4mmx`,
	"loginForm": `Dashboard_loginForm__K+b9A`,
	"backButtonContainer": `Dashboard_backButtonContainer__p4OlG`,
	"antTableCellClipped": `Dashboard_antTableCellClipped__vqFlZ`,
	"ant-alert": `Dashboard_ant-alert__9ph8y`,
	"custom-black-alert": `Dashboard_custom-black-alert__LRxt6`,
	"ant-alert-message": `Dashboard_ant-alert-message__+DCIo`,
	"ant-alert-description": `Dashboard_ant-alert-description__J9ohZ`,
	"ant-alert-icon": `Dashboard_ant-alert-icon__XgZbs`
};
export default ___CSS_LOADER_EXPORT___;
